export const FETCH_CUSTOM_FIELD_URL = `${process.env.REACT_APP_API_URL}/assets_custom_fields`;
export const CREATE_CUSTOM_FIELD_URL = `${process.env.REACT_APP_API_URL}/assets_custom_fields/create`;
export const UPDATE_CUSTOM_FIELD_URL = `${process.env.REACT_APP_API_URL}/assets_custom_fields`;
export const QUERY_CUSTOMF_FIELD_URL = `${process.env.REACT_APP_API_URL}/assets_custom_fields/query`;
